import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import { AppBar, Box, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, Checkbox, Tooltip, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, useScrollTrigger, Slide, CssBaseline, Container, Grid, Card, CardContent } from "@mui/material";

import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';

import LockReelLocation from "./StoreReelInReelLocation";
import StackWiseStockList from "./StoredReelInStock";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Searchicon from '@mui/icons-material/Search';
import LoadBinStorageDetails from "./ListOutAllBins";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const AllocateLocationForReel = ({ Warehouse_identification_number, handlecallbackAvailableSlot, reelID, storageID }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const [paymentTerms, setPaymentTerms] = useState([]);
    const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
    const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
    const [paymentTermsID, setPaymentTermsID] = useState(0);

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [slotList, setSlotList] = useState([]);


    const [viewAvailableSlots, setViewAvailableSlots] = useState(true);
    const [viewAddReelToStock, SetViewAddReelToStock] = useState(false);
    const [viewAvailableReelList, SetViewAvailableReelList] = useState(false);
    const [viewAddBundleToStock, SetViewAddBundleToStock] = useState(false);


    const [selectedStackingID, setSelectedStackingID] = useState(0);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const [selectedLocationCode, setSelectedLocationCode] = useState('');
    const [selectedRackBin, setSelectedRackBin] = useState('');
    const[selectedBinStatus,setSelectedBinStatus] = useState('');

    const [open, setOpen] = useState(false);

    const handleOpenMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    const handleCloseMenu = (setter) => () => {
        setter(null);
    };

    const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
        setSelectedOption(option);
        setSelectedID(option ? option.id : null);
        handleCloseMenu();
    };


    const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);

    const handleAddOption = (label) => () => {
        if (label == 'Warehouse') {
            setPaymentTermDialogOpen(true);
        }
    };


    // API CALL WARE    HOUSE LIST
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPaymentTerms(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);


    useEffect(() => {
        if (Warehouse_identification_number) {


            LoadAvailableSlotList();

        }
    }, [Warehouse_identification_number]);


    const LoadAvailableSlotList = () => {
        const para = {
            p_companyid: 1,
            p_id_warehouse: Warehouse_identification_number,
        }

        if (storageID === 1) {
            callApi(API_ENDPOINTS.WAREHOUSE_GET_AVAILABLE_SLOT, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setSlotList(data);
                    }
                    else {
                        setSlotList([]);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {

            callApi(API_ENDPOINTS.WAREHOUSE_GET_AVAILABLE_SLOT_FOR_BINS, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setSlotList(data);
                    }
                    else {
                        setSlotList([]);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }

    }



    const callback = () => {
        handlecallbackAvailableSlot();
    }


    // slot list
    const [filters, setFilters] = useState({
        location_code: '',
        warehouse_code: '',
        zozone_codene: '',
        aisle_code: '',
        rack_code: '',
        rack_level: '',
        bin_code: '',
    });

    // const filteredData = slotList.filter((row) => {
    //     // Check if row matches selected status
    //     if (selectedStatus === 'Open' || row.status === selectedStatus) {
    //         // Check if all filter fields match
    //         return Object.keys(filters).every((key) => {
    //             if (filters[key] === '') return true; // No filter applied
    //             return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    //         });
    //     }
    //     return false;
    // });


    const SelectedRowValues = (warehouse_id, zone_id, aisle_id, stacking_id, location, level) => {
        const location_values = 0;
        setSelectedStackingID(stacking_id);
        setSelectedLocationCode(location);
        setSelectedLevel(level);
        setViewAvailableSlots(false);
        SetViewAvailableReelList(false);
        SetViewAddReelToStock(true);

    };

  

    const callBackLockReel = () => {
        setSelectedStackingID(0);
        setViewAvailableSlots(true);
        SetViewAvailableReelList(false);
        SetViewAddReelToStock(false);
        SetViewAddBundleToStock(false);
        LoadAvailableSlotList();
    };
    const callBackLockFromBin = () => {
        setSelectedStackingID(0);
        setSelectedLocationCode(0);
        setSelectedBinStatus(0);
        setSelectedRackBin(0);       
        setViewAvailableSlots(true);
        SetViewAvailableReelList(false);
        SetViewAddReelToStock(false);
        SetViewAddBundleToStock(false);
        LoadAvailableSlotList();
    };

    const handleCallEdit = (stacking_id, location) => {
        setSelectedStackingID(stacking_id);
        setSelectedLocationCode(location);
        setViewAvailableSlots(false);
        SetViewAvailableReelList(true);
        SetViewAddBundleToStock(false);
        SetViewAddReelToStock(false);
       
    }

    const handleCallEditBundle = (stacking_id, location,binStatus,bin_id) => {
        setSelectedStackingID(stacking_id);
        setSelectedLocationCode(location);
        setSelectedBinStatus(binStatus);
        setSelectedRackBin(bin_id);
        setViewAvailableSlots(false);
        SetViewAvailableReelList(false);
        SetViewAddReelToStock(false);
        SetViewAddBundleToStock(true);
    }
    const SelectedRowValuesBin = (warehouse_id, zone_id, aisle_id, rack_id, level_id, bin_id, location,binStatus) => {
        const location_values = 0;
        setSelectedStackingID(rack_id);
        setSelectedLocationCode(location);
        setSelectedBinStatus(binStatus);
        setSelectedLevel(level_id);
        setSelectedRackBin(bin_id);
        setViewAvailableSlots(false);
        SetViewAvailableReelList(false);
        SetViewAddReelToStock(false);
        SetViewAddBundleToStock(true);
    };


    // app bar
    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Bins');
    const openFirst = Boolean(anchorElFirst);
    const [newLocation, setNewLocation] = useState(false);
    const [warehouseList, setWarehouseList] = useState(true);
    const [warehouseSlots, setWarehouseSlots] = useState(false);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Bins') {
            setSelectedStatus('All');
        }
        else if (option === 'Available Bins') {
            setSelectedStatus('open');
        }
        else if (option === 'Allocated Bins') {
            setSelectedStatus('stored');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };


    const handleShowNewVendor = () => {
        // setEditPartyID(0);
        // setWarehouseList(false);
        // setWarehouseSlots(false);
        // setNewLocation(true);
    }
   

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = slotList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    // const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    // const [selectedStatus, setSelectedStatus] = useState('All');

    const filteredData = slotList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    return (
        <Box>
            {storageID === 1 && (<>
                {viewAvailableSlots && (
                    <>
                        <Header title={'Available Slots'} subtitle="" callback={callback} />
                        <Divider />
                        <Box
                            sx={{
                                padding: "5px",
                                borderRadius: "10px",
                                maxHeight: {
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '74vh', // Medium devices (small laptops)
                                    lg: '74vh', // Large devices (desktops)
                                    xl: '82vh', // Extra large devices (large desktops)
                                },
                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: colors.primary[400],
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: colors.blueAccent[600],
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: colors.blueAccent[800],
                                    },
                                },
                                '&::-webkit-scrollbar-corner': {
                                    background: colors.primary[700],
                                }
                            }}>

                            <Grid container  >
                                <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                                    <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Box
                                            gridColumn="span 9"
                                            gridRow={"span 2"}
                                            alignItems="center"
                                            justifyContent="center"
                                            padding={1}
                                            sx={{
                                                "& .MuiTable-root": {
                                                    border: "none",
                                                    size: "small",
                                                },
                                                "& .MuiTableCell-root": {
                                                    borderBottom: "none",

                                                    border: "1px solid ",
                                                    borderColor: `${colors.primary[400]} !important`,
                                                },
                                                "& .name-column--cell": {
                                                    color: colors.greenAccent[300],
                                                },
                                                "& .MuiTableHead-root": {

                                                    borderBottom: "none",


                                                },
                                                "& .MuiTableBody-root": {
                                                    overflowY: "auto",
                                                },
                                                "& .MuiCheckbox-root": {
                                                    color: `${colors.blueAccent[200]} !important`,
                                                    size: "small",
                                                },
                                                "& .MuiTableFooter-root": {
                                                    borderTop: "none",
                                                    backgroundColor: colors.blueAccent[700],
                                                    height: "10px",
                                                },
                                                "& .MuiButton-text": {
                                                    color: `${colors.grey[100]} !important`,
                                                },

                                            }}>


                                            <TableContainer >
                                                <Table size="small">
                                                    <TableHead sx={{ height: 10 }}>
                                                        <TableRow>
                                                            <TableCell>

                                                            </TableCell>

                                                            <TableCell>LOCATION ID</TableCell>
                                                            <TableCell>WAREHOUSE NAME</TableCell>
                                                            <TableCell>ZONE CODE</TableCell>
                                                            <TableCell>AISLE CODE</TableCell>

                                                            <TableCell>STACKING POSITION</TableCell>
                                                            <TableCell>ALLOCATED PRODUCT DETAIL</TableCell>
                                                            <TableCell>STATUS</TableCell>
                                                            <TableCell>AVAILABLE VERTICAL LEVELS</TableCell>
                                                            <TableCell>
                                                                {/* <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton> */}
                                                                <Modal
                                                                    open={open}
                                                                    // onClose={handleClose}
                                                                    aria-labelledby="modal-modal-title"
                                                                    aria-describedby="modal-modal-description"
                                                                >
                                                                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                        <TextField
                                                                            label="NAME"
                                                                            name="name"
                                                                            value={slotList.warehouse_name}
                                                                            // onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Company Name"
                                                                            name="companyName"
                                                                            value={slotList.companyname}
                                                                            //onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Email"
                                                                            name="email"
                                                                            value={slotList.email}
                                                                            // onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="WorkPhone"
                                                                            name="workPhone"
                                                                            value={slotList.workphone}
                                                                            // onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Status"
                                                                            name="status"
                                                                            value={slotList.status}
                                                                            // onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Payables"
                                                                            name="payables"
                                                                            value={slotList.payales}
                                                                            //onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />

                                                                        {/* <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button> */}
                                                                    </Box>
                                                                </Modal>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {slotList.map((row) => (
                                                            <TableRow key={row.id}>
                                                                <TableCell>
                                                                    <div>

                                                                        <IconButton onClick={(event) => SelectedRowValues(row.id_warehouse, row.id_zone, row.id_aisle, row.id_stacking, row.location_code, row.allocated_reel_count)} >
                                                                            <AddCircleOutlinedIcon style={{ fontSize: "16px" }} />
                                                                        </IconButton>
                                                                    </div>

                                                                </TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleCallEdit(row.id_stacking, row.location_code)}
                                                                    >
                                                                        {row.location_code}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{row.warehouse_code}</TableCell>
                                                                <TableCell>{row.zone_code}</TableCell>
                                                                <TableCell>{row.aisle_code}</TableCell>
                                                                <TableCell>{row.stacking_code}</TableCell>
                                                                <TableCell>{row.allocated_product_status}</TableCell>
                                                                <TableCell>{row.stacking_location_status}</TableCell>
                                                                <TableCell>{row.available_slot_count}</TableCell>

                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>




                                        </Box>
                                    </Grid>
                                </Grid>

                            </Grid>

                        </Box>
                    </>
                )}
            </>)}



            {/* // bin allocation concept */}


            {storageID != 1 && (<>

                {viewAvailableSlots && (
                    <>
                <AppBar position="static" sx={{ backgroundColor: "inherit" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="inherit"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal" }} />}
                            sx={{ textTransform: 'none', fontSize: "25px", fontWeight: "semi bold" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}

                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Bins')}>All Bins</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Available Bins')}>Available Bins</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Allocated Bins')}>Allocated Bins</MenuItem>
                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        {/* <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Location</Button> */}

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ ml: 'auto' }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Vendors" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Vendors" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                {/* <ListItemIcon>
                                    <FormatAlignJustifyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reset Column Width" /> */}
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon />
                        </IconButton>

                        <div>
                            <IconButton onClick={handlecallbackAvailableSlot} >
                                <Close fontSize="inherit" style={{ color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>


                <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>
                    <Grid container  >
                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                            <Box
                                gridColumn="span 9"
                                gridRow={"span 2"}
                                alignItems="center"
                                justifyContent="center"
                                padding={1}
                                sx={{
                                    "& .MuiTable-root": {
                                        border: "none",
                                        size: "small",
                                    },
                                    "& .MuiTableCell-root": {
                                        borderBottom: "none",

                                        border: "1px solid ",
                                        borderColor: `${colors.primary[400]} !important`,
                                    },
                                    "& .name-column--cell": {
                                        color: colors.greenAccent[300],
                                    },
                                    "& .MuiTableHead-root": {

                                        borderBottom: "none",


                                    },
                                    "& .MuiTableBody-root": {
                                        overflowY: "auto",
                                    },
                                    "& .MuiCheckbox-root": {
                                        color: `${colors.blueAccent[200]} !important`,
                                        size: "small",
                                    },
                                    "& .MuiTableFooter-root": {
                                        borderTop: "none",
                                        backgroundColor: colors.blueAccent[700],
                                        height: "10px",
                                    },
                                    "& .MuiButton-text": {
                                        color: `${colors.grey[100]} !important`,
                                    },

                                }}>

                                <TableContainer >
                                    <Table size="small">
                                        <TableHead sx={{ height: 10 }}>
                                            <TableRow>
                                                <TableCell>

                                                </TableCell>

                                                <TableCell>LOCATION ID</TableCell>
                                                <TableCell>WAREHOUSE NAME</TableCell>
                                                <TableCell>ZONE CODE</TableCell>
                                                <TableCell>AISLE CODE</TableCell>

                                                <TableCell>RACK CODE</TableCell>
                                                <TableCell>RACK LEVEL</TableCell>
                                                <TableCell>BIN CODE</TableCell>
                                                <TableCell>STATUS</TableCell>
                                                <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                                    <Modal
                                                        open={open}
                                                        // onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                            <TextField
                                                                label="Location ID"
                                                                name="location_code"
                                                                value={filters.location_code}
                                                                 onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Warehouse Name"
                                                                name="warehouse_code"
                                                                value={filters.warehouse_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Zone"
                                                                name="zone_code"
                                                                value={filters.zone_code}
                                                                 onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Aisle"
                                                                name="aisle_code"
                                                                value={filters.aisle_code}
                                                                 onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Rack"
                                                                name="rack_code"
                                                                value={filters.rack_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Rack Level"
                                                                name="rack_level_code"
                                                                value={filters.rack_level_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Bins"
                                                                name="bin_code"
                                                                value={filters.bin_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {filteredData.map((row) => (
                                            // {slotList.map((row) => (
                                                <TableRow key={row.id}>
                                                    <TableCell>
                                                        <div>

                                                            <IconButton onClick={(event) => SelectedRowValuesBin(row.id_warehouse, row.id_zone, row.id_aisle, row.id_rack, row.id_rack_level, row.id_rack_bins, row.location_code,row.status)} >
                                                                <AddCircleOutlinedIcon style={{ fontSize: "16px" }} />
                                                            </IconButton>
                                                        </div>

                                                    </TableCell>
                                                    <TableCell>
                                                        <span
                                                            style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                            onClick={() => handleCallEditBundle(row.id_stacking, row.location_code,row.status,row.id_rack_bins)}
                                                        >
                                                            {row.location_code}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>{row.warehouse_code}</TableCell>
                                                    <TableCell>{row.zone_code}</TableCell>
                                                    <TableCell>{row.aisle_code}</TableCell>
                                                    <TableCell>{row.rack_code}</TableCell>
                                                    <TableCell>{row.rack_level_code}</TableCell>
                                                    <TableCell>{row.bin_code}</TableCell>
                                                    <TableCell>{row.status}</TableCell>
                                                    {/* <TableCell>{row.available_slot_count}</TableCell> */}

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>

                            </Grid>
                                </Grid>

                            </Grid>

                        </Box>

                        </>)}

                    </>)}


                    {viewAddReelToStock && (<>
                        <LockReelLocation handleCallBack={callBackLockReel} stackingID={selectedStackingID} ReelID={reelID} locationCode={selectedLocationCode} levelValue={selectedLevel} />
                    </>)}

                    {viewAvailableReelList && (
                        <StackWiseStockList stack_identification_number={selectedStackingID} handlecallbackstackList={callBackLockReel} selectedLocationCode={selectedLocationCode} />
                    )}

                    {viewAddBundleToStock && (
                        <>
                            <LoadBinStorageDetails handleCallBack={callBackLockFromBin} stackingID={selectedStackingID} ReelID={reelID} locationCode={selectedLocationCode} levelValue={selectedLevel} bin_id={selectedRackBin} selectedBinStatus={selectedBinStatus} />
                        </>
                    )}

                </Box>
                );
}
                export default AllocateLocationForReel